
import { subscriptionAwaitsConfirmation } from '~/utils/newsletterOffer'

export default {
  name: 'FooterTopFormNewsletter',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: value => ['light', 'dark'].includes(value),
    },
    showIntro: {
      type: Boolean,
      default: true,
    },
    inputId: {
      type: String,
      default: 'newsletter-email',
    },
    source: {
      type: String,
      default: 'modal',
    },
    personalisationNotice: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      email_newsletter: this.$auth.user?.email || null,
      submitting: false,
    }
  },
  computed: {
    showPersonalisationNotice() {
      return (
        this.personalisationNotice &&
        this.$auth.loggedIn &&
        this.$auth.user?.newsletter_personalised !== false
      )
    },
    canReactivateNewsletter() {
      return (
        this.$auth.loggedIn &&
        this.$auth.user?.newsletter_subscription?.id &&
        this.$auth.user?.newsletter_subscription?.newsletter_subscription_status
          ?.identifier === 'disabled' &&
        this.email_newsletter === this.$auth.user?.email
      )
    },
  },
  methods: {
    async submitNewsletter() {
      if (!this.email_newsletter || this.submitting) return
      this.submitting = true
      try {
        if (this.canReactivateNewsletter) {
          await this.$newsletterSubService
            .enable(this.$auth.user.newsletter_subscription.id)
            .then(response => {
              this.$auth.fetchUser()
              if (subscriptionAwaitsConfirmation(response)) {
                this.$trackNewsletterSignup('pending', this.source)
                this.$swalCustomSuccess(
                  this.$t(
                    'components.footerTopFormNewsletter.verificationEmailSent'
                  ),
                  this.$t(
                    'components.footerTopFormNewsletter.verificationEmailInstructions'
                  )
                )
              } else {
                this.$trackNewsletterSignup('enabled', this.source)
                this.$swalCustomSuccess(
                  this.$t(
                    'components.footerTopFormNewsletter.newsletterActivated'
                  ),
                  this.$t(
                    'components.footerTopFormNewsletter.newsletterActivatedMessage'
                  )
                )
              }
              this.$emit('subscribed', this.email_newsletter)
              this.$bvModal.hide('ModalSubscriptionNewsletter')
            })
            .catch(error => {
              this.$swalErrorMessage(error)
            })
        } else {
          await this.$newsletterSubService
            .create({ email: this.email_newsletter, source: this.source })
            .then(() => {
              this.form = []
              this.$trackNewsletterSignup('pending', this.source)
              this.$swalCustomSuccess(
                this.$t(
                  'components.footerTopFormNewsletter.verificationEmailSent'
                ),
                this.$t(
                  'components.footerTopFormNewsletter.verificationEmailInstructions'
                )
              )
              this.$emit('subscribed', this.email_newsletter)
            })
            .catch(error => {
              this.$swalErrorMessage(error)
            })
        }
      } finally {
        this.submitting = false
      }
    },
  },
}
